
import DomainService from "@/services/DomainService";
import Vue from "vue";

interface DomainLookupResult {
  domain: string;
  type: "internal";
  purchaseDate: string | null;
  subAccountId: string;
  subAccountEmail: string | null;
  domainOwnerName: string | null;
  status: string | null;
  transferStatus: string | null;
  autoRenew: boolean | null;
  expiryDate: string | null;
}

export default Vue.extend({
  data() {
    return {
      domain: "",
      errorMessage: "",
      domainError: "",
      isLoading: false,
      result: null as DomainLookupResult | null,
    };
  },
  methods: {
    async lookupDomain() {
      this.domainError = "";
      this.errorMessage = "";
      this.result = null;

      if (!this.domain) {
        this.domainError = "Domain is required.";
        return;
      }

      try {
        this.isLoading = true;
        const response = await DomainService.lookupDomain(this.domain);
        this.result = response.data;
      } catch (error: any) {
        const status = error?.response?.status;
        if (status === 404) {
          this.errorMessage = "Domain not found.";
        } else {
          this.errorMessage = error?.response?.data?.message || "An error occurred during lookup.";
        }
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
});
